// extracted by mini-css-extract-plugin
module.exports = {"information":"ConfirmGasBackBankTransfer-module__information___3x_H6"};